import React from "react";
import { fmtDuration, fmtTime } from "./geotabFormat.js";

const SUB = "mt-2 text-[10px] font-bold uppercase tracking-[0.08em] text-slate-500";
const SERVICE = "grid grid-cols-[112px_44px_minmax(0,1fr)] items-baseline gap-1.5 border-t py-0.5 text-[12px] first:border-t-0";

// « 16 min avant le départ » / « 36 min après le retour ».
const around = (minutes, event) => `${fmtDuration(minutes)} ${minutes >= 0 ? "avant" : "après"} ${event}`;

// Carnet de route Geotab autour du départ et du retour ; la route par trajet est dans « Durées par étape ».
export default function GeotabDriverDay({ row }) {
  const cmp = row.comparison;
  const duty = row.duty;
  const done = duty && !cmp.in_progress;
  const service = [
    duty && ["Début de service", fmtTime(duty.start), around(cmp.real_departure - duty.start, "le départ")],
    ["Départ du dépôt", fmtTime(cmp.real_departure), "trajet Geotab"],
    ["Retour au dépôt", fmtTime(cmp.real_return), cmp.real_return != null ? "trajet Geotab" : cmp.in_progress ? "en cours" : "aucun retour au dépôt"],
    done && ["Fin de service", fmtTime(duty.end), cmp.real_return != null ? around(cmp.real_return - duty.end, "le retour") : ""],
    done && ["Service total", fmtDuration(duty.end - duty.start), "carnet de route"],
  ].filter(Boolean);
  return (
    <section className="min-w-0 rounded-[4px] border border-slate-200 bg-white px-3 py-1.5">
      <div className="text-[12.5px] font-bold text-slate-800">Journée du chauffeur</div>
      <div className={SUB}>Carnet de route Geotab</div>
      {!duty && <p className="m-0 text-[12px] text-slate-500">Aucun carnet de route Geotab pour ce chauffeur.</p>}
      <ul className="m-0 list-none p-0">
        {service.map(([label, time, detail]) => (
          <li key={label} className={`${SERVICE} ${label === "Service total" ? "border-slate-300 font-bold" : "border-slate-100"}`}>
            <span className="text-slate-700">{label}</span><b className="tabular-nums text-slate-900">{time}</b><span className="truncate text-slate-500">{detail}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
